module.exports = __webpack_public_path__ + "static/rollover_educacion-dcfd44186643683b37b69188135ba1c3.svg";